<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<a
  class="article-link"
  [queryParamsHandling]="'merge'"
  [routerLink]="articleUrl"
>
  <article
    class="item"
    [class.bg-neutral]="colorBlack"
    [style.background-color]="backgroundColor"
  >
    <span
      data-scheme-article-publish-date
      class="item__date"
    >
      {{ resolvedArticle().publishedAt | date: 'dd.MM.YYYY' }}
    </span>
    <div class="item__wrapper">
      <div class="item__badges">
        @for (badge of badges; track badge.id) {
          <noda-articles-badge
            [badgeClasses]="badgeClasses()"
            [badgeParams]="{ tag: badge.attributes.value }"
            [text]="badge.attributes.name"
          />
        }
      </div>
      <h1
        data-scheme-article-title
        class="item__title"
        [innerHTML]="resolvedArticle().title"
      ></h1>
    </div>
    @if (imageUrl) {
      <img
        alt="article-image"
        class="item__bg"
        [src]="imageUrl"
      />
    }
    @if (iconUrl) {
      <img
        alt="article-icon"
        class="item__icon"
        [src]="iconUrl"
      />
    }
  </article>
</a>
